import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import type { ReactNode } from "react";
type Props = {
  open: boolean;
  onClose: () => void;
  kicker: string;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
};

/**
 * Bottom sheet. Inside the phone preview the Snak always renders its portrait-mobile layout,
 * so the original desktop right-hand panel variant is not used here.
 */
export function Sheet({
  open,
  onClose,
  kicker,
  title,
  children,
  footer
}: Props) {
  return <AnimatePresence data-id="element-231" data-mp="39u66yt55mo1o">
      {open && <div className="fixed inset-0 z-50 flex items-end" role="dialog" aria-modal="true" aria-label={title} data-id="element-232" data-mp="39v7kr5dk1on3">
          <motion.button aria-label="Close" onClick={onClose} className="absolute inset-0 bg-ink/25" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-233" data-mp="3eukg6eihs41a" />
          <motion.div className="relative flex max-h-[88%] w-full flex-col rounded-t-2xl bg-paper shadow-[0_-8px_40px_rgba(20,23,28,0.12)]" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 16
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-234" data-mp="z2wiuhzkg9hy">
            <div className="flex items-start justify-between gap-4 border-b border-rule px-6 pb-4 pt-5" data-id="element-235" data-mp="yw8g05h11yjw">
              <div className="min-w-0" data-id="element-236" data-mp="tz8d23fh5bx0">
                <p className="text-[12px] font-medium text-teal" data-id="element-237" data-mp="p771yku1lr8k">{kicker}</p>
                <h2 className="mt-1 font-serif text-[22px] leading-tight text-ink" data-id="element-238" data-mp="p4ue5r1lsmnl">{title}</h2>
              </div>
              <button onClick={onClose} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-rule text-charcoal transition-colors duration-150 hover:border-ink hover:text-ink" aria-label="Close panel" data-id="element-239" data-mp="g68xk1fozhpg">
                <X className="h-4 w-4" strokeWidth={1.75} data-id="element-240" data-mp="3sputng7old30" />
              </button>
            </div>
            <div className="scroll-quiet min-h-0 flex-1 overflow-y-auto px-6 py-5 text-[14px] leading-relaxed text-charcoal" data-id="element-241" data-mp="1jjz82x6fakn">
              {children}
            </div>
            {footer && <div className="border-t border-rule px-6 py-3" data-id="element-242" data-mp="3jr9gy1ow4sa5">{footer}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}